/* eslint-disable import/extensions */
import './polyfill';

// Order of @formatjs imports is important here
import '@formatjs/intl-getcanonicallocales/polyfill.js';
import '@formatjs/intl-locale/polyfill.js';
import '@formatjs/intl-pluralrules/polyfill.js';
import '@formatjs/intl-datetimeformat/polyfill.js';
import '@formatjs/intl-relativetimeformat/polyfill.js';
import '@formatjs/intl-datetimeformat/add-all-tz.js';

import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';

import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-pluralrules/locale-data/fr';
import '@formatjs/intl-pluralrules/locale-data/de';
import '@formatjs/intl-pluralrules/locale-data/es';
import '@formatjs/intl-pluralrules/locale-data/it';
import '@formatjs/intl-pluralrules/locale-data/nl';
import '@formatjs/intl-pluralrules/locale-data/no';
import '@formatjs/intl-pluralrules/locale-data/nb';
import '@formatjs/intl-pluralrules/locale-data/sv';
import '@formatjs/intl-pluralrules/locale-data/ja';
import '@formatjs/intl-pluralrules/locale-data/lt';
import '@formatjs/intl-pluralrules/locale-data/lv';

import '@formatjs/intl-datetimeformat/locale-data/en';
import '@formatjs/intl-datetimeformat/locale-data/fr';
import '@formatjs/intl-datetimeformat/locale-data/de';
import '@formatjs/intl-datetimeformat/locale-data/es';
import '@formatjs/intl-datetimeformat/locale-data/it';
import '@formatjs/intl-datetimeformat/locale-data/nl';
import '@formatjs/intl-datetimeformat/locale-data/nb';
import '@formatjs/intl-datetimeformat/locale-data/sv';
import '@formatjs/intl-datetimeformat/locale-data/pt';
import '@formatjs/intl-datetimeformat/locale-data/ro';
import '@formatjs/intl-datetimeformat/locale-data/hr';
import '@formatjs/intl-datetimeformat/locale-data/fi';
import '@formatjs/intl-datetimeformat/locale-data/et';
import '@formatjs/intl-datetimeformat/locale-data/el';
import '@formatjs/intl-datetimeformat/locale-data/da';
import '@formatjs/intl-datetimeformat/locale-data/ja';
import '@formatjs/intl-datetimeformat/locale-data/lt';
import '@formatjs/intl-datetimeformat/locale-data/lv';

import 'initSentry';
// emotionCss must be imported before App so the insertion point is set up before any component module is evaluated
import { emotionCssInsertionPoint } from 'config/emotionCss';
import { FONT_ICON_URL } from 'constants/ApiConstants';

import 'antd/dist/reset.css';

// Order of the following imports is important !
// Putting configuresStore before App will cause some UI issues at least (e.g. cookiesModal going upper than the app)
import './index.less'; // TODO: find a solution to import this after App.js
import { store } from './config/store/configureStore';
import { router } from './router';

const cache = createCache({ key: 'fleetback', insertionPoint: emotionCssInsertionPoint });

const container = document.createElement('div');
container.id = 'root';
document.body.appendChild(container);

// eslint-disable-next-line camelcase
const HASH = __webpack_hash__;

const root = createRoot(container);
root.render(
  <CacheProvider value={cache}>
    <Provider store={store}>
      <Helmet>
        <link rel="stylesheet" href={`${FONT_ICON_URL}?${HASH}`} />
      </Helmet>
      <RouterProvider router={router} />
    </Provider>
  </CacheProvider>
);
